/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState } from 'react';
import './BreakdownUtility.scss';
import { breakdownByUtilityProps } from './BreakdownUtilityProps';
import { DataTable } from '@scuf/datatable';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';

import { formatCurrency } from '../../shared/Utils/Utils';
import {
  KPI_PERCENTAGE_DECIMAL_PRECISION,
  PERCENTAGE_HUNDRED,
  TotalActualCost
} from '../Utils/Constants';
import TruncateText from '../../shared/TruncatedText/TruncateText';

const breakdownUtility = (props: breakdownByUtilityProps) => {
  const [fieldSortOrder, setFieldSortOrder] = useState<number>(-1);
  const [sortFieldName, setSortFieldName] = useState<string>(TotalActualCost);

  const { meterData, columnHeaders, utilityCostCurrency } = props;

  const cellDataRenderer = (cellData: ICellData) => {
    const { value, field } = cellData;

    if (field === 'Type') {
      return (
        <span className="table-cell-common emass-siteview-table-cell">
          <TruncateText text={value} />
        </span>
      );
    }
    if (field === 'TotalActualCost') {
      return (
        <span className="table-cell-common emass-siteview-table-cell">
          {formatCurrency(value, utilityCostCurrency)}
        </span>
      );
    }
    if (field === 'TotalActualCostPercentage') {
      // if (value !== null) {
      return (
        <span className="table-cell-common">
          {Math.round(
            (value * PERCENTAGE_HUNDRED) / PERCENTAGE_HUNDRED
          ).toFixed(KPI_PERCENTAGE_DECIMAL_PRECISION)}
          %
        </span>
      );
      // } else {
      //   return <span className="table-cell-common">--</span>;
      // }
    }
    return <></>;
  };
  return (
    <div className="Breakdown-table-container emaas-dashboard">
      <DataTable
        data={meterData}
        className="style-tableContent"
        onSort={({ sortField, sortOrder }) => {
          setFieldSortOrder(sortOrder as number);
          setSortFieldName(sortField);
        }}
        sortField={sortFieldName}
        sortOrder={fieldSortOrder}
      >
        {columnHeaders.map((header) => (
          <DataTable.Column
            key={header.toString()}
            field={header.Field}
            header={header.HeaderValue}
            renderer={cellDataRenderer}
            align={header.TextAlignValue}
          />
        ))}
      </DataTable>
    </div>
  );
};

export default breakdownUtility;
